.darkBG {
  background: #00000099;
  width: 100vw;
  height: 100vh;
  z-index: 9998;
  top: 0;
  left: 0;
  position: absolute;
  touch-action: none;
}

.centered {
  position: fixed;
  bottom: 0;
  width: 100vw;
  z-index: 99999999;
  touch-action: none;
}

.modal {
  padding: 68px 20px 40px;
  z-index: 10;
  border-radius: 32px 32px 0 0;
  backdrop-filter: blur(256px);
  background-color: #00000099;
  background-image: url(src/assets/images/modal-background.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  max-width: 750px;
  margin: 0 auto;
}

/* The container takes the focus on open so a screen reader reads the dialog; the ring belongs to
   the controls inside it, not to the sheet itself. */
.modal:focus {
  outline: none;
}

.headerImage {
  position: absolute;
  left: 50%;
  top: -48px;
  transform: translateX(-48px);
  background-image: url(src/assets/images/modal-image-background.png);
  background-size: cover;
  backdrop-filter: blur(96px);
  box-shadow: 0px 16px 32px 0px #CCFF001F;
}
